export default __webpack_public_path__ + "static/media/DouglasLopes_04.a4bfc980.jpg";